import { CommonModule } from '@angular/common';
import { Component, effect, input, output, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  selector: 'empathy-options-library-form',
  templateUrl: 'options-library-form.component.html',
  styleUrl: './options-library-form.component.scss',
  imports: [CommonModule, MatButtonModule, MatInputModule, ReactiveFormsModule]
})
export class OptionsLibraryFormComponent {
  optionSetForm = input<FormGroup>();

  create = output();
  edit = output();

  isEdit$ = signal(false);

  constructor() {
    effect(
      () => {
        if (this.optionSetForm() && this.optionSetForm().get('id').value) {
          this.isEdit$.set(true);
        } else {
          this.isEdit$.set(false);
        }
      },
      { allowSignalWrites: true }
    );
  }
}
